import React from "react";
import BaseConverters from "../components/BaseConverters";

export default function Electronics() {
  return <BaseConverters mode="electronics" />;
}
